/* Shared small bits for admin tables. */
export function Pagination({ total, skip, limit, onChange, testidPrefix }) {
  const page = Math.floor(skip / limit) + 1;
  const totalPages = Math.max(1, Math.ceil(total / limit));
  return (
    <div
      className="flex items-center justify-between gap-4 text-xs text-slate-500"
      data-testid={`${testidPrefix}-pagination`}
    >
      <div>
        Showing{" "}
        <span className="font-medium text-slate-700">
          {total === 0 ? 0 : skip + 1}–{Math.min(skip + limit, total)}
        </span>{" "}
        of <span className="font-medium text-slate-700">{total}</span>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onChange(Math.max(0, skip - limit))}
          className="rounded-md border border-slate-200 px-2.5 py-1 disabled:opacity-40"
          data-testid={`${testidPrefix}-prev`}
        >
          ← Prev
        </button>
        <span className="font-medium text-slate-700">
          {page} / {totalPages}
        </span>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onChange(skip + limit)}
          className="rounded-md border border-slate-200 px-2.5 py-1 disabled:opacity-40"
          data-testid={`${testidPrefix}-next`}
        >
          Next →
        </button>
      </div>
    </div>
  );
}

export function StatusPill({ value, tone }) {
  const tones = {
    green: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    sky: "bg-sky-50 text-sky-700 border-sky-200",
    rose: "bg-rose-50 text-rose-700 border-rose-200",
    slate: "bg-slate-100 text-slate-700 border-slate-200",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${tones[tone] || tones.slate}`}
    >
      {value}
    </span>
  );
}

export function Card({ children, className = "", testid }) {
  return (
    <div
      className={`rounded-2xl border border-slate-200 bg-white ${className}`}
      data-testid={testid}
    >
      {children}
    </div>
  );
}

export function EmptyState({ title, body, testid }) {
  return (
    <div
      className="rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-16 text-center"
      data-testid={testid}
    >
      <div className="text-sm font-medium text-slate-900">{title}</div>
      {body && <div className="mt-1 text-sm text-slate-500">{body}</div>}
    </div>
  );
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return s;
  }
}

export function fmtDateTime(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return s;
  }
}
